/**
 * Currency conversion via a USD-based rate map.
 * rate[X] means: 1 USD = rate[X] units of X.
 *
 *   amount X → Y :  amount * (rate[Y] / rate[X])
 */
export type RateMap = Record<string, number>;

export function convert(amount: number, from: string, to: string, rates: RateMap): number {
  const rf = rates[from];
  const rt = rates[to];
  if (!rf || !rt) return NaN;
  return amount * (rt / rf);
}

/** Direct rate: 1 unit of `from` in units of `to`. */
export function pairRate(from: string, to: string, rates: RateMap): number {
  return convert(1, from, to, rates);
}

export const COMMON_AMOUNTS = [1, 5, 10, 50, 100, 500, 1000, 5000];
